import Svg from '../generated/Show';
import { Icon, type IconProps } from './Icon';

export const ShowIcon = (props: IconProps) => <Icon component={Svg} name="show" {...props} />;
